import { CustomReportsListRoutePath } from "#src/routes/reports/custom-reports";
import { RoutePath } from "#src/utils/route";

export const CustomReportCreateRoutePath = CustomReportsListRoutePath.concat(
  new RoutePath<"reportVariant">({
    path: ":reportVariant/create",
    title: "Create Custom Report",
  })
);
